import dayjs from "dayjs";
import moment from "moment";

//convertDate : it will convert the date into given format
export const convertDate = (date: string, format: string) => {
  return moment.utc(date).format(format);
};

export const convertDateISO = (date: string, format: string) => {
  const cleanedDate = date.split(".")[0] + "Z";
  return moment.utc(cleanedDate).format(format);
};

export const toTitleCase = (str: string) => {
  return str.replace(/\b\w/g, char => char.toUpperCase()); 
}

// Function to build query parameters from an object
export function buildQueryParams(params: { [key: string]: any }): string {
  const queryParams = Object.keys(params)
    .filter((key) => params[key] !== undefined && params[key] !== null)
    .map((key) => `${key}=${params[key]}`)
    .join("&");
  return `?${queryParams}`;
}

// Function to determine the background color based on the answer text.
// If the answer contains 'no' or 'not', it returns a red-like background, otherwise green.
export const getBackgroundColor = (answer: string) => {
  return answer === "yes"
    ? "success-questions-border-color"
    : "error-question-border-color";
};

// Function to parse the dialogue text into a structured format
export function parseDialogue(data: any) {
  const dialogues = data?.split("<br>");
  return dialogues?.map((line: any) => {
    const [role, ...text] = line?.split(": ");
    return {
      role: role?.trim(),
      text: text?.join(": ").trim(),
    };
  });
}

export const zoneBasedDate = (dateString: string): string => {
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  const formatter = new Intl.DateTimeFormat(undefined, options);
  const formattedDate = formatter.format(date);
  const [month, day, year] = formattedDate.split("/");
  return `${month}/${day}/${year}`;
};
export function userShortName(firstName: string = '', lastName: string = '') {
  const firstInitial = firstName ? firstName[0] : '';
  const lastInitial = lastName ? lastName[0] : '';

  return `${firstInitial}${lastInitial}`.toUpperCase();
}


export const getCategoryObj = () => {
  let  categoryObj = {
    category: {
      internal_id:"",
      name: '',
      description: '',
      slug: '',
    },
    auto_failed: false,
    weightage: '',
    evaluation_type: '',
    questions: [{
      question: {
        internal_id: "",
        question_text: '',
        question_order: 0,
      },
      rule: '',
      auto_failed: false,
    }
  ],  // Updated structure to include questionsList
  };
  return categoryObj;
}

// export const getDateRange = (days: number) => {
//   const today = new Date();
// const endDate = new Date(today);
//   const startDate = new Date(today);
//   startDate.setDate(today.getDate() - days + 1); // +1 to include today
  
//   return {
//     startDate: startDate,
//     endDate: endDate
//   };
// }


export const getDateRange = (range: string) => {
  const today = dayjs();
  const enddate = today;
  let startdate = null;
  switch (range) {
    case 'last7days':
      startdate = (today.subtract(7, 'day'));     
      break;
    case 'last30days':
      startdate = (today.subtract(30, 'day'));     
      break;
    case 'last90days':
      startdate = (today.subtract(90, 'day'));     
      break;
    case 'last365days':
      startdate = (today.subtract(365, 'day'));     
      break;
    case 'custom':
      // Keep existing dates or set to null for custom range
      break;
  }

  return {
    startdate: startdate ,
    enddate: enddate
  };
}